import { Link } from 'react-router-dom';
import { Button, Result } from 'antd';
import { paths } from '@app/routes/paths';

export const EmailVerifiedPage = () => (
  <div className="flex min-h-screen items-center justify-center px-4">
    <Result
      status="success"
      title="Email verified"
      subTitle="Your email address has been confirmed."
      extra={
        <Link to={paths.dashboard}>
          <Button type="primary">Go to dashboard</Button>
        </Link>
      }
    />
  </div>
);
